export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9555.c6243bfb.jpg";